<template>
  <v-dialog v-model="show" max-width="290" persistent no-click-animation class="confirm">
    <v-card>
      <div class="fti-dialog-header">
        <div class="ml-3">{{ $t('ticketClassification') }}</div>
        <v-spacer></v-spacer>
        <v-btn flat icon @click="close">
            <v-icon color="#fff">mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <p>{{$t('ticketClassificationTitle')}}</p>
        <v-row>
          <v-col cols="12">
            <v-checkbox v-model="ticketClassification" :label="$t('ticketClassificationReportTrue')" value="2"></v-checkbox>
            <v-checkbox v-model="ticketClassification" :label="$t('ticketClassificationReportFalse')" value="1"></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="cancel" class="action-btn">
            {{ $t('cancel') | capitalize }}
        </v-btn>
        <v-btn color="primary" @click="confirm" class="action-btn">
            {{ $t('confirm') | capitalize }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      ticketClassification: ''
    };
  },
  methods: {
    close() {
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
    confirm() {
      this.show = false;
      this.$emit('confirm', this.ticketClassification);
    }
  }
};
</script>